import { Modal } from "antd";
import React from "react";
import { withRouter } from "../../utils/tms-with-router/tms-with-router";
const TmsModal = (props) => {
  return (
    <Modal
      className={props.className && props.className}
      centered={props.centered && props.centered}
      width={props.width ? props.width : "auto"}
      open={props.visible}
      title={props.title}
      onOk={props.onOk}
      height={props.height ? props.height : "auto"}
      onCancel={props.onCancel ? props.onCancel : ""}
      footer={props.footer ? props.footer : ""}
      closable={props.closable ?? false}
      maskClosable={props.maskClosable ?? false}
    >
      {props.children}
    </Modal>
  );
};
export default withRouter(TmsModal);
